module.exports = __webpack_public_path__ + "img/80ae6e6.png";